import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useApiContext } from 'react-easyrocket';

export const useResetQueriesOnLogout = () => {
  const { isAuthenticated } = useApiContext();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isAuthenticated) {
      queryClient.removeQueries({ queryKey: ['full-info'] });
      queryClient.removeQueries({ queryKey: ['deposit-methods'] });
      queryClient.removeQueries({ queryKey: ['deposit-crypto-methods'] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
};
